<div class="pos-header-search">
  <i-tabler name="search" class="pos-header-search__icon flex text-lg!" aria-hidden="true"></i-tabler>
  <input
    type="search"
    class="pos-header-search__input"
    [formControl]="search.control"
    [placeholder]="'pos.venta.search' | translate"
    [attr.aria-label]="'pos.venta.search' | translate"
    autocomplete="off"
  />
  @if (search.term()) {
    <button
      type="button"
      class="pos-header-search__clear"
      (click)="search.clear()"
      [attr.aria-label]="'pos.venta.clearSearch' | translate"
    >
      <i-tabler name="x" class="flex text-base!" aria-hidden="true"></i-tabler>
    </button>
  }
</div>
